import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Color, Font } from "../../";
var StyledComponent = styled(function (props) {
    return (_jsxs(Box, { id: props === null || props === void 0 ? void 0 : props.id, sx: {
            display: 'inline-flex',
            padding: '0.125rem',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '0.125rem'
        }, children: [_jsx(Box, { sx: {
                    display: 'flex',
                    padding: '0.25rem',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '0.625rem'
                }, children: _jsx(Typography, { sx: __assign(__assign({}, Font.defaultFontSet), { color: Color.text.primary, fontStyle: 'normal', fontWeight: 600, fontSize: "0.75rem", lineHeight: "0.875rem" }), children: props.titleText }) }), _jsx(Box, { sx: {
                    display: 'flex',
                    padding: '0.25rem',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '0.625rem'
                }, children: _jsx(Typography, { sx: __assign(__assign({}, Font.defaultFontSet), { color: Color.text.primary, fontStyle: 'normal', fontWeight: 400, fontSize: "0.75rem", lineHeight: "0.875rem" }), children: props.bodyText }) })] }));
})(function () { return ({}); });
export default StyledComponent;
